import {Link, LinkProps} from '@mui/material'
import React from 'react'

export const CARD_CHEVRON_CLASS = 'card-chevron'

export const CardLinkWrapper = <RootComponent extends React.ElementType = 'a'>(
  props: LinkProps<RootComponent>
) => (
  <Link
    {...props}
    sx={(theme) => ({
      width: '100%',
      textDecoration: 'none',
      '&:hover': {
        [`& .${CARD_CHEVRON_CLASS}`]: {
          color: theme.palette.primary.main
        }
      }
    })}
  />
)
